export default __webpack_public_path__ + "static/media/market-place.635cb459.png";